import { defineStore } from 'pinia'

export default defineStore({
  id: 'contacts',
  state: () => ({
    contactsImported: false,  //will be used to watch when a contact import runs to update related information
  })
});